export default [
  {
    path: window.pathApp + '/pagamento',
    name: 'tipo.pagamento',
    component: () => import('@/components/Pagamento/TipoPagamento'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: "Pagamento",
    }
  },
  {
    path: window.pathApp + '/confirmacao-pagamento',
    name: 'confirmacao',
    component: () => import('@/components/Pagamento/Confirmacao'),
    meta: {
      login: false,
      avisoCarrinho: false,
      title: "Confirmação de Pagamento",
    }
  },
  {
    path: window.pathApp + '/acordo',
    name: 'acordo',
    component: () => import('@/components/Pagamento/PagamentoAcordo'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: "Acordo",
    }
  },
  {
    path: window.pathApp + '/pagamento-acordo/:hash',
    name: 'pagamento-acordo',
    component: () => import('@/components/Pagamento/PagamentoAcordo'),
    meta: {
      login: false,
      avisoCarrinho: false,
      title: "Pagamento de Acordo",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/tipo_pagamento.js